<template>
<div>
  <!-- <div style="padding-top:100px;"> -->
    <v-card class="mx-auto" max-width="1000" elevation="0" style="margin:10px;">
      <v-row>
        <v-col md="3"></v-col>
        <v-col md="6">
          <h3 style="text-align:center;color:black;">
            <b>LOGIN</b>
          </h3>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="username"
              prepend-icon="mdi-account"
              label="Username/Email"
              type="text"
              required
              :rules="userRules"
            />

            <v-text-field
              id="password"
              v-model="password"
              prepend-icon="mdi-lock"
              label="Password"
              type="password"
              required
              :rules="pwdRules"
            />

            <v-card-actions>
              <v-spacer />
              <v-layout wrap justify-center>
                <v-flex xs12 md12 pt-2 text-center>
                  <v-btn
                    :disabled="false"
                    width="490px"
                    class="text-capitalize hh"
                    dark
                    :ripple="false"
                    color="#26af82"
                    @click="logininit"
                  >LOGIN</v-btn>
                </v-flex>
                <v-layout wrap justify-center>
                  <v-flex xs12 md12 pt-5 text-center>
                    <router-link to="/Forgotpassword">
                      <span style="font-size:14px;color: #ff4e00;">Forgot Password?</span>
                    </router-link>
                  </v-flex>

                  <v-flex xs12 md12 pt-3 text-center>
                    <span style="font-weight:500">Don't have an account?</span>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12 md12 pt-2 pb-6 text-center>
                    <router-link to="/SignupCommon">
                      <v-btn
                        dark
                        :ripple="false"
                        class="text-capitalize hh"
                        outlined
                        width="490px"
                      >SIGN UP</v-btn>
                    </router-link>
                  </v-flex>
                </v-layout>
              </v-layout>

              <!-- <v-btn color="#0e4e35" text @click="logininit">LOGIN</v-btn> -->
            </v-card-actions>
          </v-form>
        </v-col>
        <v-col md="3"></v-col>
      </v-row>
    </v-card>
    <br />
  </div>
</template>
<script>
import store from "../../store";
import axios from "axios";

export default {
  data() {
    return {
      valid: true,
      pwdRules: [v => !!v || " required"],
      userRules: [v => !!v || " required"],

      username: "",
      password: "",

      msg: null,
      // isLoggedIn:false,
      logindialog: false
    };
  },

  methods: {
    logininit() {
      if (this.$refs.form.validate()) {
        var data = {};
        data["username"] = this.username;
        data["password"] = this.password;
        axios({
          method: "POST",
          url: "/user/login",
          data: data
        })
          .then(response => {
            
            if (response.data.status == true) {
              store.commit("loginUser");
              localStorage.setItem("token", response.data.data.token);
              localStorage.setItem("usertype", response.data.data.type);
              localStorage.setItem("username", response.data.data.username);
              localStorage.setItem("status", response.data.status);
              localStorage.setItem("isLoggedIn", response.data.status);
              localStorage.setItem("id", response.data.data.id);
            
              this.msg = " login successfull ";
              this.$dlg.alert(
                this.msg,
                () => {
                  if ((response.data.data.type == 'Seller')) {
                      store.commit("isSeller", "true");
                    this.$router.push("/ProductList/");
                    window.location.reload();
                  } else if ((response.data.data.type =='Client')) {
                      store.commit("isClient", "true");
                    this.$router.push("/firstpage");
                    window.location.reload();
                  }
                },
                { messageType: "success" }
              );
            } else {
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
            }
          })
          .catch(e => {
            this.msg = "Not Success";
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          });

        // axios({
        //   method: "POST",
        //   url: "/user/login",
        //   data: {
        //     username: this.login.username,
        //     password: this.login.password
        //   }
        // })
        //   .then(response => {
        //       this.status = response.data.status
        //   this.msg = response.data.msg
        //   if (this.status === true) {
        //       store.commit("loginUser", request.data);
        //       localStorage.setItem("token", response.data.data.token);
        //       localStorage.setItem("usertype", response.data.type);
        //       localStorage.setItem("isLoggedIn", response.data.status);
        //       if (response.data.usertype == "client") {
        //         store.commit("customer", request.data);
        //         localStorage.setItem("isCustomer", "true");
        //       }
        //       else
        //        if (response.data.usertype == "seller") {
        //         store.commit("seller", request.data);
        //         localStorage.setItem("seller", "true");
        //       }
        //         this.msg = "login successfull";
        //         this.$dlg.alert(
        //         this.msg,
        //         () => {
        //           this.$router.push("/firstpage/");
        //            window.location.reload();
        //         },
        //         { messageType: "success" }
        //       );
        //     } else {
        //       this.msg = response.data.msg;
        //       this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        //     }

        //   })
        //      .catch(e => {
        //     this.msg = "Not Success";
        //     this.$dlg.alert(
        //       this.msg,
        //       () => {

        //       },
        //       { messageType: "error" }
        //     );
        //   });
      }
    }
  }
};
</script>
<style scoped>
.hh {
  background-color: #ff4e00;
  background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
}
</style>